.container {
  display: flex;
  width: 400px;
  height: 300px;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-family: monospace;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  color: var(--gray300);
  border: 1px solid var(--gray200);
  border-top: none;
  border-left: none;
}
